export default __webpack_public_path__ + "static/media/Mexico.045f220e.svg";